import {DateGroupGranularityType} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/DatePropertyTypeStrategy/enum/DateGroupGranularityType'
import {IDatePropertyTypeFullValue} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/DatePropertyTypeStrategy/types/IDatePropertyTypeInterfaces'
import {
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  format,
  isValid,
  parseISO,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
} from 'date-fns'

const ISO_DATE_FORMAT = 'yyyy-MM-dd'

const bucketRangeByGranularity: Partial<Record<DateGroupGranularityType, (date: Date) => {start: Date, end: Date}>> = {
  [DateGroupGranularityType.Week]: (date) => ({
    start: startOfWeek(date, {weekStartsOn: 1}),
    end: endOfWeek(date, {weekStartsOn: 1}),
  }),
  [DateGroupGranularityType.Month]: (date) => ({
    start: startOfMonth(date),
    end: endOfMonth(date),
  }),
  [DateGroupGranularityType.Quarter]: (date) => ({
    start: startOfQuarter(date),
    end: endOfQuarter(date),
  }),
  [DateGroupGranularityType.Year]: (date) => ({
    start: startOfYear(date),
    end: endOfYear(date),
  }),
}

export function bucketDateValueByGranularity(
  fullValue: IDatePropertyTypeFullValue | null,
  granularity: string | null | undefined,
): IDatePropertyTypeFullValue | null {
  if(!fullValue?.from?.date || !granularity || granularity === DateGroupGranularityType.Day) {
    return fullValue
  }
  const date = parseISO(fullValue.from.date)
  if(!isValid(date)) {
    return fullValue
  }
  const resolveRange = bucketRangeByGranularity[granularity as DateGroupGranularityType]
  if(!resolveRange) {
    return fullValue
  }
  const {start, end} = resolveRange(date)
  return {
    from: {
      date: format(start, ISO_DATE_FORMAT),
      time: null,
    },
    to: {
      date: format(end, ISO_DATE_FORMAT),
      time: null,
    },
  }
}
